const state = {
    view: {
        left: 'none',
        center: 'block',
        right: 'none',
    }
};
const getters = {
    currentView: state => state.view,
};

const actions = {
    async setView({ commit }, view) {
        commit('viewSetter', view)
    }
};
const mutations = {
    viewSetter(state, view) {
        state.view = view
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};